import { create } from "zustand"

interface NetworkStoreState {
  isOnline: boolean
  setIsOnline: (value: boolean) => void
}

const getInitialOnlineStatus = (): boolean => {
  if (typeof navigator === "undefined") return true
  return navigator.onLine
}

export const useNetworkStore = create<NetworkStoreState>((set) => ({
  isOnline: getInitialOnlineStatus(),
  setIsOnline: (value) => set({ isOnline: value }),
}))
